import React from 'react'
import {ActionButtons} from './ActionButtons'
import {FrameworkBadges} from './FrameworkBadges'
import {StatusBadge} from './StatusBadge'
import OwnerDisplay from 'app/components/OwnerDisplay'

interface ControlRowProps {
  control: any
  index: number
  isTrialPlan: boolean
  activeRowId: string
  selectAll: boolean
  checkedItems: string[]
  currentUser: any
  showAllFrameworks: boolean
  handleCheckChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleOpenModal: (id: string) => void
  toggleDropdown: () => void
  handleDeleteClick: (control: any) => void
  handleActivateControl: (control: any) => void
  handleDeactivateControl: (control: any) => void
  setShowAllFrameworks: (show: boolean) => void
  tests: any[]
  processControlValues: (
    inputString: string,
    inputString2: string,
    testIds: string[],
    documentIds: string[],
    tests: any[]
  ) => string
  currentAuditContext: any
}

export const ControlRow: React.FC<ControlRowProps> = ({
  control,
  index,
  isTrialPlan,
  activeRowId,
  selectAll,
  checkedItems,
  currentUser,
  showAllFrameworks,
  handleCheckChange,
  handleOpenModal,
  toggleDropdown,
  handleDeleteClick,
  handleActivateControl,
  handleDeactivateControl,
  setShowAllFrameworks,
  tests,
  processControlValues,
  currentAuditContext
}) => {
  const isBlurred = isTrialPlan && index >= 5

  return (
    <tr
      key={control.id}
      style={{
        ...(isBlurred ? {filter: 'blur(4px)', pointerEvents: 'none'} : {}),
        height: '60px',
      }}
      className={`${activeRowId === control.id ? 'bg-gray-100' : ''}`}
    >
      <td>
        <div className='form-check form-check-sm form-check-custom form-check-solid'>
          <input
            className='form-check-input widget-9-check'
            type='checkbox'
            value={control.id}
            checked={selectAll || checkedItems.includes(control.id)}
            onChange={handleCheckChange}
          />
        </div>
      </td>
      <td>
        <span
          className='text-dark fw-bold text-hover-primary fs-6 cursor-pointer'
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            if (!isTrialPlan || index < 5) {
              handleOpenModal(control.id)
            }
          }}
        >
          {control.control_title}
        </span>
      </td>
      <td>
        <OwnerDisplay owner={control.control_owner} uid={control.control_uid} />
      </td>
      <td>
        <StatusBadge status={control.control_evidence_status} />
      </td>
      <td>
        <div className='d-flex flex-column'>
          <span className='fs-7 py-1 fw-semibold'>
            <FrameworkBadges
              mappings={control.control_framework_mappings}
              showAll={showAllFrameworks}
              toggleShow={() => setShowAllFrameworks(true)}
            />
          </span>
        </div>
      </td>
      <td>
        <span className='text-muted me-2 fs-7 fw-semibold'>
          {processControlValues(
            control.control_document,
            control.control_test,
            control.test_id,
            control.document_id,
            tests
          )}
        </span>
      </td>
      <td>
        <div className='fs-6 fw-semibold fw-block'>
          {control.author ? control.author : 'SecureSlate'}
        </div>
      </td>
      <td>
        {isTrialPlan && index >= 5 ? (
          <></>
        ) : (
          <div className='dropdown mx-2' style={{position: 'relative'}}>
            <button
              className='btn btn-secondary border-0 p-0 m-2'
              type='button'
              id='dropdownMenu2'
              data-bs-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
            >
              <img src='/media/buttons/Options.svg' alt='Options' onClick={toggleDropdown} />
            </button>
            <ActionButtons
              control={control}
              currentUser={currentUser}
              handleOpenModal={handleOpenModal}
              handleDeleteClick={handleDeleteClick}
              handleActivateControl={handleActivateControl}
              handleDeactivateControl={handleDeactivateControl}
              currentAuditContext={currentAuditContext}
            />
          </div>
        )}
      </td>
    </tr>
  )
}
